module.exports = __webpack_public_path__ + "img/heart.f3d3f7f2.svg";